/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Faq_TitleInputs */

const en_mk_sec_pg_faq_title = /** @type {(inputs: Mk_Sec_Pg_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions people ask`)
};

const id_mk_sec_pg_faq_title = /** @type {(inputs: Mk_Sec_Pg_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan yang sering diajukan`)
};

/**
* | output |
* | --- |
* | "Questions people ask" |
*
* @param {Mk_Sec_Pg_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_faq_title = /** @type {((inputs?: Mk_Sec_Pg_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_faq_title(inputs)
	return en_mk_sec_pg_faq_title(inputs)
});